export default {
  st_config: {
    API_BASE_URL: 'https://api.pico2chain.com/api/'
  }
}